import { Modal } from 'antd';
import React from 'react';

import MobileButton from './Button';

export default function ModalFooter({
	open = false,
	setIsModalOpen = () => {},
	typeModal = '',
	content = null,

	...otherProps
}) {
	return (
		<Modal
			title=""
			{...otherProps}
			open={open}
			footer={false}
			className="modal_footer hide_on_desktop show_on_mobile"
			closable={false}>
			{content}
			<MobileButton
				onClick={() => setIsModalOpen(false)}
				text={typeModal === 'disclaimer' ? 'OK' : 'CANCEL'}
				className={`disclaimer-btn ${typeModal === 'needhelp' ? 'btn-white' : 'btn-green'}`}
			/>
		</Modal>
	);
}
